export default __webpack_public_path__ + "static/media/closeUpOne.84b9356c.png";